import { render, staticRenderFns } from "./PlpListRefinement.vue?vue&type=template&id=00bdf4aa&scoped=true&"
import script from "./PlpListRefinement.vue?vue&type=script&lang=js&"
export * from "./PlpListRefinement.vue?vue&type=script&lang=js&"
import style0 from "./PlpListRefinement.vue?vue&type=style&index=0&id=00bdf4aa&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bdf4aa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppCheckbox: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppCheckbox.vue').default,AppRadiobox: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppRadiobox.vue').default,AppExpansionPanel: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppExpansionPanel.vue').default})
